// extracted by mini-css-extract-plugin
module.exports = {"item":"_9e1425b4d3--item--qvtPS"};